import moment from 'moment';
import _ from 'lodash';

export function formatBinsReportToGraphData(binsData) {
  const boxNames = Object.keys(binsData);
  return boxNames.map((boxName, i) => {
    const boxData = binsData[boxName];
    const chartDataObj = {
      name: boxName.slice(0, boxName.length > 10 ? 25 : 40),
      data: [],
    };

    if (boxData && boxData.length > 0) {
      chartDataObj.data = boxData.map((box) => {
        return {
          // x: moment(box.utilization_date)
          //   .tz(getTimeZone())
          //   .set('hour', 13)
          //   .valueOf(),
          x: new Date(box.utilization_date).getTime(),
          y: _.round(
            ((box.total_bins - box.available_bins) / box.total_bins) * 100,
            3
          ),
          totalBins: box.total_bins,
          availableBins: box.available_bins,
        };
      });
    }
    return chartDataObj;
  });
}

export function formatOrdersReportToGraphData(ordersData, dataDurationInDays) {
  const stockedData = [],
    pickedUpData = [];

  const chartDates = Array.from({ length: dataDurationInDays }, (_, i) =>
    moment()
      .subtract(i, dataDurationInDays)
      .format('YYYY-MM-DD')
  ).reverse();

  chartDates.forEach((chartDate) => {
    if (ordersData[chartDate] && Array.isArray(ordersData[chartDate])) {
      const [stocked, picked_up] = ordersData[chartDate].reduce(
        ([stocked, picked_up], dataObj) => {
          return [
            stocked + (parseInt(dataObj.stocked, 0) || 0),
            picked_up + (parseInt(dataObj.picked_up, 0) || 0),
          ];
        },
        [0, 0]
      );
      stockedData.push([moment(chartDate).valueOf(), stocked]);
      pickedUpData.push([moment(chartDate).valueOf(), picked_up]);
    } else {
      stockedData.push([moment(chartDate).valueOf(), 0]);
      pickedUpData.push([moment(chartDate).valueOf(), 0]);
    }
  });

  return [
    { name: 'Stocked', data: stockedData },
    { name: 'Picked Up', data: pickedUpData },
  ];
}

//     const boxData = ordersData[boxName];
//     const chartDataObj = {
//       name: boxName.slice(0, maxBoxNameLabelLength),
//       data: [],
//       visible: i < defaultShowPerbatch ? undefined : false,
//     };

//     if (boxData && boxData.length > 0) {
//       chartDataObj.data = boxData.map((box) => {
//         if (!box.stocked) box.stocked = 0;
//         if (!box.picked_up) box.picked_up = 0;

//         return {
//           x: moment(box.date)
//             .tz(getTimeZone())
//             .set('hour', 13)
//             .valueOf(),
//           // if both zero then 0 else if stocked is zero and picked_up is non-zero then 100 else calculate percentage
//           y:
//             !box.stocked && !box.picked_up
//               ? 0.0
//               : !box.stocked
//               ? 100.0
//               : _.round((box.picked_up / box.stocked) * 100, 3),
//           stocked: box.stocked,
//           picked_up: box.picked_up,
//         };
//       });
//     }
//     return chartDataObj;
//   });
// }

export function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return true;
  });
  return stabilizedThis.map((el) => el[0]);
}

export function getSorting(order, orderBy) {
  const desc = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  };

  return order === 'desc'
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

export function gettingOnSortTableName(field) {
  if (['box'].includes(field)) return 'boxes';
  if (['store'].includes(field)) return 'accounts';
  return '';
}



// WEBPACK FOOTER //
// ./src/components/reports/kiosk-box-utilization/helpers/data.helpers.js